<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <div :class="css.container" class="container">
            <h1 :class="css.header" class="font-variable font-bold color-1">{{ $t("EnsemblNCBI") }}</h1>
            <section :class="css.contents">
                <div :class="css.content">
                    <!-- * 按钮组 -->
                    <ui-radio-group :class="css.radios" class="font-variable font-bold color-1" v-model="mode">
                        <ui-radio :class="[css.radio, css_normalize.radio]" value="ncbi">
                            <span>NCBI</span>
                            <img src="https://rdgta.cdn.cyagen.com/rddc/images/bio/arrow.webp" alt="" />
                            <span>Ensembl</span>
                        </ui-radio>
                        <ui-radio :class="[css.radio, css_normalize.radio]" value="ensembl">
                            <span>Ensembl</span>
                            <img src="https://rdgta.cdn.cyagen.com/rddc/images/bio/arrow.webp" alt="" />
                            <span>NCBI</span>
                        </ui-radio>
                    </ui-radio-group>

                    <ui-form :class="css.modules" :data="data">
                        <ui-form-item :class="css.module" direction="column" :label="$t('Species')">
                            <ui-select v-model="data.species" width="100%" :candidates="vars.species" />
                        </ui-form-item>

                        <ui-form-item :class="css.module" direction="column" :label="$t('Gene')">
                            <ui-input v-model="data.id" width="100%" :placeholder="$t('PleaseEnterGeneGeneIDOptional')" />
                        </ui-form-item>

                        <ui-form-item :class="css.module" direction="column" :label="$t('TranscriptID')">
                            <ui-input v-model="data.transcript" width="100%" :placeholder="$t('PleaseEnterTranscriptIDOptional')" />
                        </ui-form-item>

                        <ui-form-item :class="css.module" direction="column" :label="$t('ProteinID')">
                            <ui-input v-model="data.protein" width="100%" :placeholder="$t('PleaseEnterProteinIDOptional')" />
                        </ui-form-item>
                    </ui-form>

                    <ui-button :class="css.submit" :disabled="disabled" @click="methods.submit">{{ $t("Convert") }}</ui-button>
                </div>

                <div :class="css.next"></div>

                <div :class="css.content">
                    <div :class="css.name" class="font-variable font-bold color-1">{{ name }}</div>

                    <ui-form :class="css.modules" :data="data">
                        <ui-form-item :class="css.module" direction="column" :label="$t('Species')">
                            <div :class="css.result">
                                <span class="ellipsis">{{ useSpeciesName(result.species, "arabia") || "No corresponding data." }}</span>
                            </div>
                        </ui-form-item>

                        <ui-form-item :class="css.module" direction="column" :label="$t('Gene')">
                            <div :class="css.result">
                                <span class="ellipsis">{{ result.id }}</span>
                            </div>
                        </ui-form-item>

                        <ui-form-item :class="css.module" direction="column" :label="$t('TranscriptID')">
                            <div :class="css.result">
                                <span class="ellipsis">{{ result.transcript }}</span>
                            </div>
                        </ui-form-item>

                        <ui-form-item :class="css.module" direction="column" :label="$t('ProteinID')">
                            <div :class="css.result">
                                <span class="ellipsis">{{ result.protein }}</span>
                            </div>
                        </ui-form-item>
                    </ui-form>
                </div>
            </section>
            <h2 :class="css.notes" class="font-variable font-normal">{{ $t("EnsemblNCBINotes") }}</h2>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiRadioGroup, UiFormItem, UiSelect, UiButton, UiRadio, UiInput, UiForm } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组合函数
const { vars, refs, data, result, methods, computeds } = useComposable();
const { name, disabled } = computeds;
const { mode } = refs;
</script>
